import React from "react";
import { Button } from "../ui/button";
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from "react-router-dom";

const PageHeader = ({ routeTo, title, description, backTo }) => {
    const navigate = useNavigate();
    return (
        <>
            <div className="flex gap-4 flex-col justify-center items-start">
                <Button variant="ghost" onClick={() => navigate(routeTo)}>
                    <ArrowLeft className="mr-2 h-4 w-4" />
                    Back to {backTo}
                </Button>
                <div>
                    <h2 className="text-3xl font-bold">{title}</h2>
                    <p className="text-muted-foreground">{description}</p>
                </div>
            </div>
        </>
    );
}
export default PageHeader;